export default {
  common: {
    empty: "暫無資料",
  },
  nav: {
    home: "首頁",
    explore: "探索出版物",
    openAccess: "開放取用文章",
    about: "關於我們",
    searchPlaceholder: "搜尋出版物/作者...",
  },
  home: {
    statPublications: "出版物",
    statAuthors: "作者",
    statDownloads: "下載",
    exploreTitle: "探索出版物",
    bookRecommend: "書籍推薦",
    videoTitle: "作者影片",
    authorIntro: "作者簡介",
    authorSuffix: " 編著",
    more: "更多",
  },
  about: {
    missionBtn: "城大出版社<br>開放取用計劃",
    openAccessBtn: "出版物版權",
    missionTitle: "城大出版社開放取用計劃",
    missionContent:
      "香港城市大學出版社於1996年成立，今年適逢30週年，我們將繼續秉承宗旨，致力推動學術研究與知識轉移。隨着學術出版向數位開放轉型的趨勢，我們與時俱進，推出專屬的開放取用（Open Access）計劃 <span class=\"brand-color\">innOAccess</span> ，以配合學術界的發展需求。\n\n本社為所有新出版的學術著作提供全新開放取用（OA）平台。該平台由中國最大的學術資源傳播平台CNKI建設。此舉為讀者提供免費、即時的線上閱讀渠道，進一步推動全球開放學術資源，讓頂尖研究成果廣傳遠播。",
    openAccessTitle: "出版物版權",
    openAccessContent:
      '本平台所有圖書均採用創用CC授權條款 <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" class="license-link">CC BY-NC-ND 4.0</a>。歡迎以任何媒介或形式自由分享、傳播圖書內容，但僅限於非商業用途，且須註明作者姓名及保持圖書的原始形式。',
  },
  privacy: {
    title: "私隱政策",
    statementTitle: "私隱政策聲明",
    statementContent:
      "香港城市大學（「大學」）在其資料管理政策及行事方式中，承諾遵照保障資料原則，並遵守香港的個人資料(私隱)條例。大學已發出<a href=\"#\" class=\"text-link\">關於個人資料（私隱）問題的實務守則</a><a href=\"#\" class=\"text-link\">（「實務守則」）</a>，為員工就收集、持有及使用個人紀錄資料的事宜提供指引。該等個人紀錄資料包括教職員、學生、校友及向大學申請職位或入學的個人資料。\n\n大學倘以電子或紙本方式向閣下收集用作識別閣下的資料，將說明收集資料的用途。將收集自閣下的個人資料保密，並按大學保密的方式，就實務守則所訂的用途轉交至相關部門。大學亦已作出行政安排，可讓閣下提出查閱及改正大學持有閣下個人資料的要求。",
    cookieTitle: "「Cookie」政策",
    cookieContent:
      "香港城市大學使用「曲奇」（cookies)及「網頁標籤」（page tagging)紀錄瀏覽我們的網頁資料，但不會收集任何識別使用者的個人資料。該等瀏覽資料將由大學或其選定編輯我們網頁使用統計的第三方服務供應商收集、儲存及處理，以追蹤我們的社交媒體訊息及網上廣告的表現。",
    sessionTitle: "曲奇 (Cookies)",
    sessionContent:
      "Cookie是用者在瀏覽網頁時由互聯網瀏覽器製成的少量數據，通常包括一個隱名的獨有識別標記。這類cookie可用作識別電腦，但不會收集任何個人資料。換言之，cookie不會識別瀏覽網站的個別用者。城大使用cookies是為儲存用者的喜好，紀錄用者瀏覽城大網頁的資數作統計，並分析用者的使用習慣。城大在某些情況下或會將收得的用者使用習慣用於第三方網頁的廣告。閣下可在其瀏覽器的設定中接受或拒絕cookies。倘若選擇拒絕，閣下或不能使用城大網頁的某些功能。",
    pageTagTitle: "網頁標籤 (Page Tagging)",
    pageTagContent:
      "我們使用了網絡信標(page beacons)、像素(pixels)、再營銷標籤(remarketing tags)，以收集及統計用者使用城大網頁的習慣，並追蹤我們網上廣告的成效。我們的某些網頁會標明運用上述技術的圖像，以收集用者的活動資料。有關資料分析後，將量度使用我們網頁及網上廣告的成效，以作改進。上述技術不會收集識別用者的個人資料。倘若閣下想取消這些追蹤功能，可在閣下的互聯網瀏覽器取消cookies。如要限制追蹤，亦可在互聯網瀏覽器以私人/私隱模式瀏覽我們的網頁，或安裝可阻止這類追蹤的工具及附加功能。",
  },
  disclaimer: {
    title: "免責聲明",
    content:
      "本網站提供的所有資料，可作修訂及定期檢視。倘對該等資料有疑問、或相信閣下的版權被侵犯或希望移除對閣下網頁的超連結，請通知本網站管理員：",
    email: "upress@cityu.edu.hk",
  },
  footer: {
    explore: "探索出版物",
    openAccess: "開放取用文章",
    about: "關於我們",
    disclaimer: "免責聲明",
    privacy: "私隱政策",
    copyright: "© 2026 City University of Hong Kong. All Rights Reserved.",
  },
  explore: {
    sortBy: "排序方式：",
    sortPublishDate: "出版時間",
    prevPage: "上一頁",
    nextPage: "下一頁",
  },
  search: {
    resultPrefix: "搜索結果：",
    resultCountPrefix: "共 ",
    resultCountSuffix: " 本",
  },
  bookDetail: {
    detail: "書籍詳情",
    author: "作者",
    publishDate: "出版日期",
    pages: "頁數",
    introduction: "書籍簡介",
    downloadEbook: "下載電子書",
    purchasePaperBook: "購買紙本書",
    authorIntro: "作者簡介",
    relatedBooks: "相關書籍推薦",
    editorSingle: ' 編',
    editorPlural: ' 編',
  },
  articleDetail: {
    researchTopic: "研究主題：",
    journal: "學術期刊：",
    author: "作者：",
    publishDate: "刊發日期：",
    pageViews: "文章訪問數：",
    viewsSuffix: " 次瀏覽",
    abstract: "摘要",
    downloadPDF: "查看全文PDF",
    relatedArticles: "相關文章",
  },
  authors: {
    title: "作者列表",
    sortLabel: "排列方式：",
    sortStroke: "按名筆畫排序",
    sortPinyin: "按名首字母排序",
    sortPublications: "可按出版書籍數量排序",
  },
  authorDetail: {
    title: "作者簡介",
    publishedBooks: "出版圖書",
  },
  openAccess: {
    hotTopicLabel: "熱門話題",
    topicCategory: "話題分類",
    disciplineCategory: "學科領域",
    totalArticles: "目前顯示第 1 至大類，共 {count} 篇結果",
    list: {
      researchTopic: "研究主題：",
      researcher: "研究者：",
      disciplinaryField: "學科領域：",
      publicationDate: "刊出日期：",
      abstract: "內容簡介：",
      sortRelevance: "相關度",
      sortPublicationDate: "刊出日期",
    },
  },
};
